/**
 * Контракты итога сессии.
 *
 * Пользователю показывается максимум три рекомендации: перегрузка статистикой
 * мешает вернуться к практике (ТЗ §7.7).
 */

import type {
  GrowthReport,
  ProgressIndicators,
  TypingMetrics,
  XpTransaction,
} from '@type2x/shared-contracts';

/** Слабое место в понятной пользователю форме. */
export interface WeakZone {
  readonly content: string;
  readonly reason: 'errors' | 'hesitation' | 'corrections';
  readonly severity: number;
}

/**
 * Рекомендация следующего шага.
 *
 * Только вид: ключ сообщения строит экран из него. Раньше рекомендация несла
 * ещё и строку ключа — придуманную здесь и никем не проверенную.
 */
export interface Recommendation {
  readonly kind: 'accuracy' | 'speed' | 'review' | 'control-test' | 'rest';
}

/** Итог сессии для экрана результата. */
export interface SessionOutcomeSummary {
  readonly metrics: TypingMetrics;
  readonly growth: GrowthReport | null;
  readonly indicators: ProgressIndicators;
  readonly weakZones: readonly WeakZone[];
  readonly xpAwarded: readonly XpTransaction[];
  readonly totalXp: number;
  readonly level: number;
  readonly recommendations: readonly Recommendation[];
}

/** Максимум рекомендаций на экране результата. */
export const MAX_RECOMMENDATIONS = 3;

/** Сколько слабых зон показывать. */
export const MAX_WEAK_ZONES = 5;
